import React from 'react';
import PdfViewer from './PdfViewer';

const URL_PDF = 'https://global.divhunt.com/d7c6bab4ffe07b47c938a5a997c24b69_388271.pdf';

export default function ColdCallScript() {
  return (
    <PdfViewer
      eyebrow="Cold calling script"
      title="Say it simply. Book the call."
      intro="Our cold calling script. View it here, open it full screen, or download a copy."
      url={URL_PDF}
      frameTitle="Cold calling script"
    />
  );
}